import { mapServerToSpecificationsBase } from "./map-server-to-specifications-base.js";
import { getSharedFrameSpecificationItems } from "../../../shared/mappers/server-to-client/specification-mappers/shared/get-shared-frame-specification-items.js";
import { getUnlocalizedSpecificationItem } from "../../../../utils/mappers/server-to-client/utils/get-unlocalized-specification-item.js";
import { getSpecificationItems } from "../../../../utils/mappers/server-to-client/utils/get-specification-items.js";
const mapServerToSunglassesSpecifications = (serverVariant, brand, locale, prescriptionGlass) => {
  const {
    segment,
    trend,
    lensFeatures,
    frameFeatures,
    roadworthiness,
    targetGender,
    targetGenderAllLocales
  } = serverVariant.variantTypeDetails;
  const genderUnlocalized = getUnlocalizedSpecificationItem(targetGenderAllLocales);
  return [
    ...mapServerToSpecificationsBase(serverVariant, brand, locale),
    ...getSpecificationItems({
      targetGender,
      genderUnlocalized,
      roadworthiness
    }),
    ...getSharedFrameSpecificationItems({
      segment,
      trend,
      lensFeatures,
      frameFeatures,
      prescriptionGlass
    })
  ];
};
export {
  mapServerToSunglassesSpecifications
};
//# sourceMappingURL=map-server-to-sunglasses-specifications.js.map
